// Autenticacion
export const AUTENTICADO = "AUTENTICADO";
export const INICIAR_SESION = "INICIAR_SESION";
export const CERRAR_SESION = "CERRAR_SESION";
export const AUTENTICADO_ERROR = "AUTENTICADO_ERROR";
// Platos
export const OBTENER_PLATOS = "OBTENER_PLATOS";
export const ALMACENANDO_PLATO = "ALMACENANDO_PLATO";
export const PREPARANDO_PLATO = "PREPARANDO_PLATO";
export const LIMPIAR_ESTADO_PLATOS = "LIMPIAR_ESTADO_PLATOS";
export const SELECCIONAR_PLATO = "SELECCIONAR_PLATO";
export const DESELECCIONAR_PLATO = "DESELECCIONAR_PLATO";
// Menus
export const OBTENER_MENUS = "OBTENER_MENUS";
export const CREAR_NUEVO_MENU = "CREAR_NUEVO_MENU";
export const PREPARAR_NUEVO_MENU = "PREPARAR_NUEVO_MENU";
export const LIMPIAR_ESTADO_MENUS = "LIMPIAR_ESTADO_MENUS";
